import axios from 'axios';
import Quotation from '../models/SFModels/Quotation';

const API_URL =
  process.env.REACT_APP_ENV === 'local'
    ? `${process.env.REACT_APP_API_LOCAL}/salesforce/quotation`
    : process.env.REACT_APP_ENV === 'production'
      ? `${process.env.REACT_APP_API_PRODUCTION}/salesforce/quotation`
      : `${process.env.REACT_APP_API_STAGING}/salesforce/quotation`;

const quotationApi = {
  fetchQuotation(opportunityId) {
    return axios.get(`${API_URL}${opportunityId}`).then(response => {
      const { id, opportunityId, productLines } = response.data;
      return new Quotation(id, opportunityId, productLines);
    });
  },
};

export default quotationApi;



// WEBPACK FOOTER //
// ./src/api/quotation.js